module.exports = __webpack_public_path__ + "static/media/client-logo.32c6126c.svg";